export default {
  methods: {
    view(eventId) {
      this.$router.push(`/certification/view/${eventId}`);
    },
    edit(eventId) {
      this.$router.push(`/certification/edit/${eventId}`);
    },
    lock(eventId) {
      this.$store.dispatch("Event/lock", eventId);
    },
    unlock(eventId) {
      this.$store.dispatch("Event/unlock", eventId);
    },
    uploadProgramme(eventId) {
      this.uploadEventId = eventId;
      this.uploadShow = true;
    },
    remove(id, eventName) {
      let h = this.$createElement;
      let msg = [
        h("p", "Czy na pewno usunąć wydarzenie"),
        h("p", [h("strong", `${eventName}?`)])
      ];

      this.deleteDialog(msg).then(confirm => {
        if (confirm) {
          this.$store.dispatch("Event/remove", id);
        }
      });
    },
    reload() {}
  }
};
